(function () {
  // Fix: el carrusel de "Te pueden gustar" (Swiper) no tiene el modulo de
  // accesibilidad de Swiper habilitado. Los slides fuera de vista siguen en el
  // orden de tabulacion y no tienen aria-hidden, asi que un usuario de teclado
  // o lector de pantalla navega por links invisibles sin ningun indicio de que
  // esto es un carrusel. Este script agrega los atributos ARIA y gestiona el
  // tabindex de los slides no visibles, sin tocar el JS minificado de Swiper.

  function getFocusable(slide) {
    return slide.querySelectorAll('a[href], button, input, [tabindex]');
  }

  function updateSlideA11y(swiperEl) {
    var slides = swiperEl.querySelectorAll('.swiper-slide');
    slides.forEach(function (slide) {
      var visible = slide.classList.contains('swiper-slide-visible') || slide.classList.contains('swiper-slide-active');
      var focusables = getFocusable(slide);
      if (visible) {
        slide.removeAttribute('aria-hidden');
        focusables.forEach(function (el) { el.removeAttribute('tabindex'); });
      } else {
        slide.setAttribute('aria-hidden', 'true');
        focusables.forEach(function (el) { el.setAttribute('tabindex', '-1'); });
      }
    });
  }

  function enhanceSwiper(swiperEl) {
    if (swiperEl.__a11yEnhanced) return;
    if (!swiperEl.querySelector('.swiper-slide')) return;
    swiperEl.__a11yEnhanced = true;

    swiperEl.setAttribute('role', 'region');
    swiperEl.setAttribute('aria-roledescription', 'carousel');
    var wrap = swiperEl.closest('product-recommendations') || swiperEl.closest('.product-recommendations');
    var heading = wrap ? wrap.querySelector('.product-recommendations-title') : null;
    swiperEl.setAttribute('aria-label', heading ? heading.textContent.trim() : 'Carrusel de productos');

    updateSlideA11y(swiperEl);

    var attempts = 0;
    (function trySwiper() {
      attempts++;
      if (swiperEl.swiper) {
        swiperEl.swiper.on('slideChange', function () { updateSlideA11y(swiperEl); });
        swiperEl.swiper.on('transitionEnd', function () { updateSlideA11y(swiperEl); });
        swiperEl.swiper.on('resize', function () { updateSlideA11y(swiperEl); });
      } else if (attempts < 40) {
        setTimeout(trySwiper, 250);
      }
    })();

    // Observer acotado al propio carrusel (no a document.body) para no repetir
    // el problema de rendimiento de otros observers del sitio.
    var slideObserver = new MutationObserver(function () { updateSlideA11y(swiperEl); });
    slideObserver.observe(swiperEl, { attributes: true, subtree: true, attributeFilter: ['class'] });
  }

  function scan() {
    document.querySelectorAll('.products-recommendations-swiper').forEach(enhanceSwiper);
  }

  document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);
  scan();

  // El carrusel se inserta via fetch dentro del custom element
  // <product-recommendations>, que si existe de entrada en el HTML (vacio).
  // En vez de solo hacer polling con limite de tiempo, observamos ese elemento
  // puntual para reaccionar en cuanto se inserte el contenido, sin importar
  // cuanto tarde el fetch.
  document.querySelectorAll('product-recommendations').forEach(function (host) {
    var obs = new MutationObserver(scan);
    obs.observe(host, { childList: true, subtree: true });
  });

  // Fallback por si el custom element se agrega despues (secciones dinamicas).
  var pollCount = 0;
  var pollTimer = setInterval(function () {
    pollCount++;
    scan();
    document.querySelectorAll('product-recommendations').forEach(function (host) {
      if (!host.__a11yObserved) {
        host.__a11yObserved = true;
        var obs = new MutationObserver(scan);
        obs.observe(host, { childList: true, subtree: true });
      }
    });
    if (pollCount > 40) clearInterval(pollTimer);
  }, 500);
})();
